---
en:
  personal_tokens:
    connect:
      copy_prompt: Copy connect prompt
      prompt: 'Connect to the Kaia Portal MCP server. Transport: http. URL: {url}. Header: Authorization: Bearer {token}. Then list the power plants you can see.'
      step_copy: Copy the token above; it is not shown again.
      step_tell: Give your AI assistant the MCP address {url} and the token, and ask it to connect. Or paste the ready-made prompt below.
      step_verify: Ask it to list the power plants it can see. If you get a list, you are connected.
      title: Connect your AI assistant
    copy: Copy token
    create: Create token
    created_title: Token created
    created_warning: Copy it now. This token is not shown again. Share it only with the AI assistant you are connecting; if in doubt, revoke it here and create a new one.
    days: "{count} days"
    done: Done
    empty: No tokens yet.
    errors:
      lifetime: Lifetime must be one of %{allowed} days
      minting_paused: Creating personal MCP tokens is paused
    expires: Expires {date}
    hint: For MCP clients acting as you. Same plant access as this account.
    last_used: Last used {date}
    lifetime: Expires in
    name: Token name
    name_hint: Name it after the device or client it lives on.
    never_used: Never used
    paused: Creating tokens is paused while we finish the compliance review of the MCP server. Existing tokens have been revoked. We are working on bringing it back.
    revoke: Revoke
    revoke_named: Revoke {name}
    revoke_text: "{name} stops working immediately. This cannot be undone."
    revoke_title: Revoke token?
    status:
      active: Active
      expired: Expired
      expires_soon: Expires soon
      revoked: Revoked
    title: Personal access tokens
    toast:
      copied: Token copied to clipboard
      copy_failed: Could not copy. Select the token and copy it manually.
      create_failed: Could not create token
      created: Token created
      load_failed: Could not load tokens
      prompt_copied: Connect prompt copied to clipboard
      revoke_failed: Could not revoke token
      revoked: Token revoked
